import { render, staticRenderFns } from "./monthly_staffsalaries.vue?vue&type=template&id=6a1bde6f&"
import script from "./monthly_staffsalaries.vue?vue&type=script&lang=js&"
export * from "./monthly_staffsalaries.vue?vue&type=script&lang=js&"
import style0 from "./monthly_staffsalaries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports